<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{'Open bill found'|translate}}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar style="font-size: 36px; color: red; font-weight: bold;">
        {{'Customer has to pay!'|translate}}
        <a routerLink="/pos/{{virtualReceipt.customer.id}}" (click)="matDialogRef.close('close')">{{'Go to bill'|translate}}</a>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close('close')"
                aria-label="Confirm">
            {{'Confirm'|translate}}
        </button>
    </div>
</div>
